import { lazy } from 'react';

export const routes = [
  {
    path: "/",
    exact: true,
    name: "Welcome",
    component:lazy(() => import("./containers/Welcome"))
  },
  {
      path: "/welcome",
      exact: true,
      component: lazy(() => import("./containers/Welcome")),
      name: "Welcome"
  },
  {
    path: "/dashboard",
    exact: true,
    component: lazy(() => import("./containers/Welcome")),
    name: "Welcome"
}
];
